import { render, staticRenderFns } from "./TituloPagina.vue?vue&type=template&id=3834e90a&scoped=true&lang=pug"
import script from "./TituloPagina.vue?vue&type=script&lang=js"
export * from "./TituloPagina.vue?vue&type=script&lang=js"
import style0 from "./TituloPagina.styl?vue&type=style&index=0&id=3834e90a&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3834e90a",
  null
  
)

export default component.exports